import styled, { css } from 'styled-components';
import {
  fillVillaIconWithColor,
  FlexCenteredColumn,
  FlexColumn,
  transitionStyles
} from '../../styled/common';
import { Typography } from '../ui/Typography';

export const StepsModalTitle = styled(Typography)``;

export const StepsModalContentContainer = styled(FlexColumn)`
  padding: 40px 20px 0;
  gap: 30px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 650px;
    padding: 60px;
    background-color: ${({ theme: { colors } }) => colors.background.primary};
    border-radius: 14px;
    gap: 40px;
  }

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    width: 720px;
  }
`;

const containerStateStyles = (color: string, isLeasedOption: boolean) => css`
  border-color: ${({ theme }) => theme.colors.systemColors.blue};
  ${transitionStyles('border-color')}

  span {
    ${transitionStyles('color')};
    color: ${color};
  }

  &:nth-of-type(1),
  &:nth-of-type(3),
  &:nth-of-type(4),
  &:nth-of-type(5) {
    svg path,
    svg rect {
      ${transitionStyles('stroke')}
      stroke: ${color};
    }
  }

  &:nth-of-type(6) {
    svg path {
      fill: ${color};
      ${transitionStyles('fill')}
    }
  }

  &:nth-of-type(2) {
    ${fillVillaIconWithColor(color)};
  }

  ${isLeasedOption &&
  css`
    &:nth-of-type(1),
    &:nth-of-type(2) {
      svg path,
      svg rect {
        fill: ${color};
        ${transitionStyles('fill')}
      }
    }
  `}
`;

export const StepModalOption = styled(FlexCenteredColumn)<{
  $isLeasedOption?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  padding: 30px 15px;
  gap: 15px;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      ${({ theme, $isLeasedOption }) =>
        containerStateStyles(theme.colors.systemColors.blue, $isLeasedOption)};
    }
  }
`;

export const StepModalOptionText = styled(Typography)``;
